import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {utils} from "../../utils"

class OIDCLogin extends Component {
    componentDidMount() {
        document.title = 'Logistic GPS Tracker | Login';
        if (!this.props.isLogout) {
            if (!this.props.loggedIn) {
                utils.redirect_oidc();
            }
        } else {
            utils.redirect_oidc_logout();
        }
    }

    render() {
        const {loggedIn, location} = this.props;
        const redir = loggedIn ? (
            location.state ? (
                <Redirect to={location.state.from}/>
            ) : (
                <Redirect to="/"/>
            )
        ) : null;
        return (
            <React.Fragment>
                {redir}
                <div className="loading2">
                    <div className="lds-grid">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <br/>
                    <b>Now Loading ...</b>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (store) => ({
    user: store.auth.user,
    error: store.auth.error,
    loggedIn: store.auth.loggedIn,
    isLogout: store.auth.isLogout
});

export default connect(mapStateToProps)(OIDCLogin);
